import { SET_STATUS } from './actions';

const setStatus = (state, { id, status }) => ({
  ...state,
  [id]: { status },
});

const reducer = {
  [SET_STATUS]: setStatus,
};

export default (state = {}, action) => (
  action.type && reducer[action.type] ? reducer[action.type](state, action) : state
);
